import React, { useEffect, useState } from 'react'
import { capitalizeFirstLetter, formateDate, formateDateWithTime, getCompany } from '../../helpers/commonFunctions';
import { getAllLoggedInUser, getTodaysOrders, getTodaysTransactions } from '../../services/company_panel/dashboardServices';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../components/company_panel/common/loader';
import notFound from '../../assets/company/img/no-record-found.png';
import RsuiteCustomPagination from '../../components/company_panel/common/rsuitPagination';
import CustomModal from '../../components/company_panel/common/customModal';

const DashboardList = ({ dateFilter }) => {

    const params = useParams();
    const navigate = useNavigate();
    const [search, setSearch] = useState({})
    const [globalSearch, setGlobalSearch] = useState("");
    const [sorting, setSorting] = useState({});
    const [page, setPage] = useState(1);
    const [orderPage, setOrderPage] = useState(1);
    const [transitionPage, setTransitionPage] = useState(1);
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [dataLength, setDataLength] = useState()
    const [orderDataLength, setOrderDataLength] = useState()
    const [transitionDataLength, setTransitionDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(8)
    const [loader, setLoader] = useState(true)
    const [statsUpdate, setStatusUpdate] = useState("false")
    const [loggedInUser, setLoggedInUser] = useState([]);
    const [todaysOrders, setTodaysOrders] = useState([]);
    const [todaysTransitions, setTodaysTransition] = useState([]);
    const [activeButton, setActiveButton] = useState("loggedInUsers");
    const [modalData, setModalData] = useState([]);

    useEffect(() => {
        if (search && activeButton === "loggedInUsers") {
            setLoader(true)
            setTimeout(() => {
                const formData = new FormData();
                formData.append("page", page)
                formData.append("per_page", itemPerPage)
                formData.append("sort", JSON.stringify(sorting))
                formData.append("search", JSON.stringify(search))
                formData.append("global_search", globalSearch)
                formData.append("company_id", getCompany().company_id);
                if (dateFilter?.start_date) formData.append("start_date", dateFilter.start_date);
                if (dateFilter?.end_date) formData.append("end_date", dateFilter.end_date);
                getAllLoggedInUser(formData).then(data => {
                    setDataLength(data.data.response.count);
                    setLoggedInUser(data && data.data && data?.data?.response ? data?.data?.response?.rows : [])
                    setLoader(false)
                }).catch(error => {
                    console.log("error ====> ", error);
                })
            }, 500);
        }
    }, [sorting, search, globalSearch, statsUpdate, page, activeButton, dateFilter?.start_date, dateFilter?.end_date]);

    useEffect(() => {
        if (search && activeButton === "todaysOrders") {
            setLoader(true)
            setTimeout(() => {
                const formData = new FormData();
                formData.append("page", orderPage)
                formData.append("per_page", itemPerPage)
                formData.append("sort", JSON.stringify(sorting))
                formData.append("search", JSON.stringify(search))
                formData.append("global_search", globalSearch)
                formData.append("company_id", getCompany().company_id);
                if (dateFilter?.start_date) formData.append("start_date", dateFilter.start_date);
                if (dateFilter?.end_date) formData.append("end_date", dateFilter.end_date);
                getTodaysOrders(formData).then(data => {
                    setOrderDataLength(data.data.response.count);
                    setTodaysOrders(data && data.data && data?.data?.response ? data?.data?.response?.rows : [])
                    setLoader(false)
                }).catch(error => {
                    console.log("error ====> ", error);
                })
            }, 500);
        }
    }, [sorting, search, globalSearch, statsUpdate, orderPage, activeButton, dateFilter?.start_date, dateFilter?.end_date]);

    useEffect(() => {
        if (search && activeButton === "todaysTransitions") {
            setLoader(true)
            setTimeout(() => {
                const formData = new FormData();
                formData.append("page", transitionPage)
                formData.append("per_page", itemPerPage)
                formData.append("sort", JSON.stringify(sorting))
                formData.append("search", JSON.stringify(search))
                formData.append("global_search", globalSearch)
                formData.append("company_id", getCompany().company_id);
                if (dateFilter?.start_date) formData.append("start_date", dateFilter.start_date);
                if (dateFilter?.end_date) formData.append("end_date", dateFilter.end_date);
                getTodaysTransactions(formData).then(data => {
                    setTransitionDataLength(data.data.response.count);
                    setTodaysTransition(data && data.data && data?.data?.response ? data?.data?.response?.rows : [])
                    setLoader(false)
                }).catch(error => {
                    console.log("error ====> ", error);
                })
            }, 500);
        }
    }, [sorting, search, globalSearch, statsUpdate, transitionPage, activeButton, dateFilter?.start_date, dateFilter?.end_date]);

    function renderCommaSeparatedList(items) {
        return (
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '5px',
                maxWidth: 'auto',
                padding: '0',
            }}>
                {items.map((item, idx) => (
                    <span key={idx} style={{ whiteSpace: 'nowrap', fontSize: '14px' }}>
                        {capitalizeFirstLetter(item)}{idx < items.length - 1 ? ', ' : ''}
                    </span>
                ))}
            </div>
        );
    }
    const getOrderItemsNames = (data) => {
        return data && (
            <div className="d-flex flex-wrap">
                {data?.slice(0,2).map((menuItems, index) => (
                    <span key={index} className="mx-1 text-capitalize">
                        {menuItems}
                        {index < data?.menu_items?.length - 1 && ', '}
                    </span>
                ))}
                {data?.length > 2 &&
                    <span
                        className="link-text cp"
                        data-bs-target="#exampleModalToggle"
                        data-bs-toggle="modal"
                        onClick={() => setModalData(data)} 
                    >
                        ...
                    </span>
                }
            </div>
        );
    };

    const viewOrderFunction = (id) => {
        navigate(`/company/transaction/order/view/${id}`);
    }

    const viewTransitionFunction = (row) => {
        navigate(`/company/transaction/transaction/view/${row}`)
    }

    const printTransition = (row, index) => {
        const printContent = `
            <div style="max-width: 600px; margin: auto; padding: 20px; border: 1px solid #ccc; border-radius: 5px;">
                <h1 style="text-align: left; color: #333;">${row?.order_id || 'N/A'}</h1>
                <h2 style="text-align: center; color: #333;">Invoice</h2>
                <hr style="border: 1px solid #ccc;">
                <div style="margin-bottom: 20px;">
                    <h3 style="color: #666;">Transaction Details</h3>
                    <p><strong>Transaction ID:</strong> ${row?.transaction_id || 'N/A'}</p>
                    <p><strong>Customer Name:</strong> ${row?.customer?.customer_name ? capitalizeFirstLetter(row?.customer?.customer_name) : 'N/A'}</p>
                    <p><strong>Customer Number:</strong> ${row.customer?.customer_number || 'N/A'}</p>
                    <p><strong>Order ID:</strong> ${row?.order_id || 'N/A'}</p>
                    <p><strong>Amount:</strong> ${row.amount ? row.amount + " SAR" : 'N/A'}</p>
                    <p><strong>Status:</strong> ${row.payment_status ? capitalizeFirstLetter(row.payment_status) : 'N/A'}</p>
                    <p><strong>Payment Method:</strong> ${row.payment_method ? capitalizeFirstLetter(row.payment_method) : 'N/A'}</p>
                </div>
                <hr style="border: 1px solid #ccc;">
                <p style="text-align: center; font-style: italic;">Thank you for your business!</p>
            </div>
        `;

        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(`
            <html>
                <head>
                    <title>Invoice Print</title>
                    <style>
                        body { font-family: Arial, sans-serif; }
                        h2 { margin-bottom: 10px; }
                        h3 { margin: 10px 0; }
                        p { line-height: 1.5; margin: 5px 0; }
                        hr { margin: 20px 0; }
                    </style>
                </head>
                <body>
                    ${printContent}
                </body>
            </html>
        `);
        doc.close();

        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
    };

    return (
        <>
            <div className='card mt-4'>
                <div className='card-header d-flex align-items-center justify-content-between'>
                    <div className="card-header-left">
                        <h4>Recent Activities</h4>
                    </div>
                    <div className="card-header-right">
                        <ul className="nav nav-pills" id="pills-tab2" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button onClick={() => setActiveButton("loggedInUsers")} className="nav-link active" id="pills-Logged-Users-tab" data-bs-toggle="pill" data-bs-target="#pills-Logged-Users" type="button" role="tab" aria-controls="pills-Logged-Users" aria-selected="true">Logged Users</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button onClick={() => setActiveButton("todaysOrders")} className="nav-link" id="pills-Today-orders-tab" data-bs-toggle="pill" data-bs-target="#pills-Today-orders" type="button" role="tab" aria-controls="pills-Today-orders" aria-selected="false">Today's orders</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button onClick={() => setActiveButton("todaysTransitions")} className="nav-link" id="pills-Today-payment-tab" data-bs-toggle="pill" data-bs-target="#pills-Today-payment" type="button" role="tab" aria-controls="pills-Today-payment" aria-selected="false">Today's payment</button>
                            </li>
                        </ul>
                    </div>
                </div>

                {activeButton === "loggedInUsers" && <div className="tabler-wrap">
                    <div className="table-responsive">
                        <table className="table table-custom">
                            <thead>
                                <tr>
                                    <th style={{ width: '33%' }} className='action_head'>Name</th>
                                    <th style={{ width: '33%' }} className='action_head'>Role</th>
                                    <th style={{ width: '33%' }} className='action_head'>Date</th>
                                </tr>
                            </thead>

                            <tbody>
                                {loader ?
                                    <tr>
                                        <td colSpan={11}><Loader /></td>
                                    </tr> :
                                    <>
                                        {loggedInUser?.length > 0 ? (
                                            loggedInUser?.map((user, index) => (
                                                <tr key={index}>
                                                    <td>{`${user?.first_name} ${user?.last_name}`}</td>
                                                    <td>{user?.platform_user_role?.name ? user?.platform_user_role?.name : "-"}</td>
                                                    <td>{"21-23-2345"}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={9} className="text-center p-5">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p className='mt-3'>No Logged User found</p>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='tabler-footer'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                            {dataLength && dataLength > 0 ?
                                // <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "user", path: "/company/dashboard" }]} /> 

                                <RsuiteCustomPagination
                                    datalength={dataLength}
                                    itemperpage={itemPerPage}
                                    setPage={setPage}
                                    currentPage={page}
                                />

                                : ""}
                        </div>
                    </div>
                </div>}

                {activeButton === "todaysOrders" && <div className="tabler-wrap">
                    <div className="table-responsive">
                        <table className="table table-custom">
                            <thead>
                                <tr>
                                    <th style={{ width: '' }} className='action_head'>Order Id</th>
                                    <th style={{ width: '' }} className='action_head'>Order Mode</th>
                                    <th style={{ width: '' }} className='action_head'>Aggregator Name</th>
                                    <th style={{ width: '' }} className='action_head'>Aggregator ID</th>
                                    <th style={{ width: '' }} className='action_head'>Ordered By</th>
                                    <th style={{ width: '' }} className='action_head'>Customer</th>
                                    <th style={{ width: '' }} className='action_head'>Contact</th>
                                    <th style={{ width: '' }} className='action_head'>Menu Items</th>
                                    <th style={{ width: '' }} className='action_head'>Brand</th>
                                    <th style={{ width: '' }} className='action_head'>Outlet</th>
                                    <th style={{ width: '' }} className='action_head'>Created At</th>
                                    <th style={{ width: '' }} className='action_head'>Price</th>
                                    <th style={{ width: '' }} className='action_head'>Payment Method</th>
                                    <th style={{ width: '' }} className='action_head'>Payment Status</th>
                                    <th style={{ width: '' }} className='action_head'>Status</th>
                                    <th style={{ width: '' }} className='action_head'>Business Date</th>
                                    <th style={{ width: '' }} className='action_head text-end'>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {loader ?
                                    <tr>
                                        <td colSpan={17}><Loader /></td>
                                    </tr> :
                                    <>
                                        {todaysOrders?.length > 0 ? (
                                            todaysOrders?.map((order, index) => (
                                                <tr key={index}>
                                                    <td>{order?.id ? order?.id : "-"}</td>
                                                    <td>{order?.order_mode_configuration?.name ? capitalizeFirstLetter(order?.order_mode_configuration?.name) : "-"}</td>
                                                    <td>{order?.aggregators_configuration?.name ? capitalizeFirstLetter(order?.aggregators_configuration?.name) : "N/A"}</td>
                                                    <td>{order?.aggregator_external_id ? order?.aggregator_external_id : "N/A"}</td>
                                                    <td>{order?.order_source == 'online' ? 'Online' : (order?.user ? `${capitalizeFirstLetter(order?.user?.first_name)} ${capitalizeFirstLetter(order?.user?.last_name)}` : "N/A")}</td>
                                                    <td>{order?.customer?.customer_name ? capitalizeFirstLetter(order?.customer?.customer_name) : "-"}</td>
                                                    <td>{order?.customer?.customer_number ? order?.customer?.customer_number : "-"}</td>
                                                    <td>{getOrderItemsNames(order?.menu_item_names)}</td>
                                                    <td>{order?.brand?.name ? order?.brand?.name : "-"}</td>
                                                    <td>{order?.outlet?.outlet_name ? order?.outlet?.outlet_name : "-"}</td>
                                                    <td>{order?.created_at ? formateDateWithTime(order?.created_at) : "-"}</td>
                                                    <td>{order?.transaction?.payment_status === 'paid' ? order?.transaction?.amount : "-"}</td>
                                                    <td>{order?.transaction?.tender_name ? capitalizeFirstLetter(order?.transaction?.tender_name) : "-"}</td>
                                                    <td>{order?.transaction?.payment_status ? capitalizeFirstLetter(order?.transaction?.payment_status) : "-"}</td>
                                                    <td>{order?.order_status ? (order.order_status == "in_kitchen" ? "In kitchen" : capitalizeFirstLetter(order.order_status)) : "-"}</td>
                                                    <td>{order?.business_date ? formateDate(order?.business_date) : "N/A"}</td>
                                                    <td className='text-end'>
                                                        <div className="dropdown d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <div className='dropdown-item' onClick={() => { viewOrderFunction(order?.id) }}>
                                                                        <i className="ti ti-eye" aria-hidden="true"></i> View details
                                                                    </div>
                                                                </li>
                                                            </ul>

                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={17} className="text-center p-5">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p className='mt-3'>No Order found</p>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='tabler-footer'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {orderDataLength ? orderDataLength : "0"}</b></div>
                            {orderDataLength && orderDataLength > 0 ?
                                // <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "user", path: "/company/dashboard" }]} /> 

                                < RsuiteCustomPagination
                                    datalength={orderDataLength}
                                    itemperpage={itemPerPage}
                                    setPage={setOrderPage}
                                    currentPage={orderPage}
                                />
                                : ""}
                        </div>
                    </div>
                </div>}

                {activeButton === "todaysTransitions" && <div className="tabler-wrap">
                    <div className="table-responsive">
                        <table className="table table-custom">
                            <thead>
                                <tr>
                                    <th style={{ width: '' }} className='action_head'>Transaction ID</th>
                                    <th style={{ width: '' }} className='action_head'>Customer Name</th>
                                    <th style={{ width: '' }} className='action_head'>Customer Number</th>
                                    <th style={{ width: '' }} className='action_head'>Order ID</th>
                                    <th style={{ width: '' }} className='action_head'>Order Mode</th>
                                    <th style={{ width: '' }} className='action_head'>Aggregator Name</th>
                                    <th style={{ width: '' }} className='action_head'>Ordered By</th>
                                    <th style={{ width: '' }} className='action_head'>Amount</th>
                                    <th style={{ width: '' }} className='action_head'>Payment Method</th>
                                    <th style={{ width: '' }} className='action_head'>Payment Status</th>
                                    <th style={{ width: '' }} className='action_head'>Created At</th>
                                    <th style={{ width: '' }} className='action_head'>Business Date</th>
                                    <th style={{ width: '' }} className='action_head text-end'>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {loader ?
                                    <tr>
                                        <td colSpan={13}><Loader /></td>
                                    </tr> :
                                    <>
                                        {todaysTransitions?.length > 0 ? (
                                            todaysTransitions?.map((transition, index) => (
                                                <tr key={index}>
                                                    <td>#{transition?.transaction_id ? transition?.transaction_id : 'N/A'}</td>
                                                    <td>{transition?.customer?.customer_name ? capitalizeFirstLetter(transition?.customer?.customer_name) : 'N/A'}</td>
                                                    <td>{transition?.customer?.customer_number ? transition?.customer?.customer_number : '-'}</td>
                                                    <td>#{transition?.customer_order?.id ? transition?.customer_order?.id : 'N/A'}</td>
                                                    <td>{transition?.customer_order?.order_mode_configuration?.name ? capitalizeFirstLetter(transition?.customer_order?.order_mode_configuration?.name) : 'N/A'}</td>
                                                    <td>{transition?.customer_order?.aggregators_configuration?.name ? capitalizeFirstLetter(transition?.customer_order?.aggregators_configuration?.name) : 'N/A'}</td>
                                                    <td>{transition?.customer_order?.user ? `${capitalizeFirstLetter(transition?.customer_order?.user?.first_name)} ${capitalizeFirstLetter(transition?.customer_order?.user?.last_name)}` : 'N/A'}</td>
                                                    <td>{transition?.amount ? transition?.amount + " " + "SAR" : 'N/A'}</td>
                                                    <td>{transition?.tender_name ? capitalizeFirstLetter(transition?.tender_name) : 'N/A'}</td>
                                                    <td>
                                                        {
                                                            transition?.payment_status
                                                            ?
                                                                transition?.payment_status != 'refunded'
                                                                ?   capitalizeFirstLetter(transition?.payment_status)
                                                                :   transition?.refundReason?.type_of_refund == 'full' ? 'Refunded' : 'Partial Refunded'
                                                            : "N/A"
                                                        }
                                                    </td>
                                                    <td>
                                                        {new Date(transition?.created_at).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true,
                                                        }).replace(',', '')}
                                                    </td>
                                                    <td>{transition?.business_date ? formateDate(transition?.business_date) : 'N/A'}</td>
                                                    <td className='text-end'>
                                                        <div className="dropdown d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <div className='dropdown-item' onClick={() => { viewTransitionFunction(transition?.id) }}>
                                                                        <i className="ti ti-eye" aria-hidden="true"></i> View details
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className='dropdown-item' onClick={() => { printTransition(transition.id) }}>
                                                                        <i className="ti ti-printer" aria-hidden="true"></i> Print
                                                                    </div>
                                                                </li>
                                                            </ul>

                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={13} className="text-center p-5">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p className='mt-3'>No Transaction found</p>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='tabler-footer'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {transitionDataLength ? transitionDataLength : "0"}</b></div>
                            {transitionDataLength && transitionDataLength > 0 ?
                                // <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "user", path: "/company/dashboard" }]} /> 

                                < RsuiteCustomPagination
                                    datalength={transitionDataLength}
                                    itemperpage={itemPerPage}
                                    setPage={setTransitionPage}
                                    currentPage={transitionPage}
                                />
                                : ""}
                        </div>
                    </div>
                </div>}

            </div>
            <CustomModal
                title="Food Items name"
                content={modalData} 
            />
        </>
    )
}

export default DashboardList;
